import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../pages/admin/common.css';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';
import config from '../../../config/config.js';
import dayjs from 'dayjs';
import qs from 'qs';
import { Link } from 'react-router-dom'; 

function Blog({ role }) {
  const blogsPerPage = 10;
  const [value, setValue] = useState('');
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState('Industry News'); 
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [blogId, setBlogId] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);




  useEffect(() => {
    const fetchCategoriesAndTags = async () => {
      setIsLoading(true);
      try {
        const categoriesRes = await axios.post(`${config.API_BASE_URL}/get_categories.php`, null, {
          withCredentials: true,
        });
        if (categoriesRes.data.success) {
          setCategories(categoriesRes.data.categories || []);
        } else {
          toast.error('Failed to load categories.');
        }

        const tagsRes = await axios.post(`${config.API_BASE_URL}/get_tags.php`, null, {
          withCredentials: true,
        });
        if (tagsRes.data.success) {
          setTags(tagsRes.data.categories || []);
        } else {
          toast.error('Failed to load tags.');
        }
      } catch (error) {
        toast.error('Error fetching categories or tags.');
        console.error('Error:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCategoriesAndTags();
  }, []);


  const fetchBlogs = async (page = 1) => {
    setIsLoading(true);
    try {
      const res = await fetch(`${config.API_BASE_URL}/view_blogs.php?page=${page}&limit=10`); // Adjust as needed
      const data = await res.json();

      console.log(data);
  
      setBlogs(data.data.blogs);

      setCurrentPage(data.data.pagination.currentPage);
setTotalPages(data.data.pagination.totalPages);


    } catch (error) {
      console.error('Error fetching blogs:', error);
    }
    setIsLoading(false);
  };
  
  

  useEffect(() => {
    fetchBlogs();
  }, []);
  


  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('title', e.target.title.value);
    formData.append('slug', e.target.slug.value);
    formData.append('category', category);
    formData.append('tags', selectedTags);
    formData.append('content', value);
    formData.append('date', selectedDate);
    formData.append('created_by', e.target.created_by.value);
    formData.append('image1', e.target.image1.files[0]);
    formData.append('image2', e.target.image2.files[0]);
    formData.append('image3', e.target.image3.files[0]);
    formData.append('banner', e.target.banner.files[0]);

    setIsLoading(true);

    try {
      let response;
      if (isEditMode) {
        formData.append('id', blogId);
        response = await axios.post(`${config.API_BASE_URL}/update_blog.php`, formData, {
          withCredentials: true,
        });
      } else {
        response = await axios.post(`${config.API_BASE_URL}/insert_blog.php`, formData, {
          withCredentials: true,
        });
      }

      if (response.data.success) {
        toast.success(isEditMode ? 'Blog updated successfully!' : 'Blog created successfully!');
        setIsEditMode(false);
        setBlogId(null);
        setSelectedDate(null);
        setValue('');
        setSelectedTags([]);
        fetchBlogs();

        setTimeout(() => {
          window.location.reload();
        }, 3000);

      } else {
        toast.error('Failed to submit the blog.');
      }
    } catch (error) {
      toast.error('Error while submitting the blog.');
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = async (id) => {
    try {
      const response = await axios.get(`${config.API_BASE_URL}/edit_blog.php?id=${id}`, {
        withCredentials: true,
      });
      if (response.data.success) {
        const blog = response.data.blog;
        setBlogId(blog.id);
        setCategory(blog.category);
        setSelectedDate(dayjs(blog.created_at));
        setValue(blog.content);
        setSelectedTags(blog.tags.split(','));
        setIsEditMode(true);

        document.querySelector('input[name="title"]').value = blog.title;
        document.querySelector('input[name="slug"]').value = blog.slug;
        document.querySelector('input[name="created_by"]').value = blog.created_by;
      } else {
        toast.error('Failed to fetch blog for editing.');
      }
    } catch (error) {
      toast.error('Error fetching blog for editing.');
      console.error('Error:', error);
    }
  };


  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this blog?')) {
      try {
        const response = await axios.delete(
          `${config.API_BASE_URL}/delete_blog.php?id=${id}`,
          { withCredentials: true }
        );
  
        if (response.data.success) {
          toast.success('Blog deleted successfully!');
          
          setTimeout(() => {
            window.location.reload();
          }, 3000);
  
        } else {
          toast.error(response.data.message || 'Failed to delete blog.');
        }
      } catch (error) {
        toast.error('Error deleting blog.');
        console.error('Error:', error);
      }
    }
  };
  
  
  


  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleToggle = async (blogId, field, value) => {
    try {
      const response = await fetch('https://api.skepper.in/blog_status.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: blogId,
          field: field,
          value: value
        }),
      });
  
      const data = await response.json();
  
      if (data.success) {
        console.log(`Updated ${field} successfully to ${value}`);
        window.location.reload();
      } else {
        console.error(`Failed to update ${field}: ${data.message}`);
      }
    } catch (error) {
      console.error('Error toggling blog status:', error);
    }
  };
  

  return (
    <>
      <div className="container-fluid category_form_sec mb-5">
        <h1 className="dashboard_heading">Blog</h1>
        <form onSubmit={handleFormSubmit}>
          <Row>
            <Col md={4}>
              <label htmlFor="category">Category</label>
              <Form.Select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                disabled={isLoading}
              >
                {categories && categories.length > 0 ? (
                  categories.map((cat) => (
                    <option key={cat.name} value={cat.name}>{cat.name}</option>
                  ))
                ) : (
                  <option value="">No categories available</option>
                )}
              </Form.Select>
            </Col>

            <Col md={4}>
              <label htmlFor="date">Date</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    value={selectedDate || null}
                    onChange={setSelectedDate}
                    sx={{ width: '100%' }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Col>

            <Col md={4}>
              <label htmlFor="created_by">Author</label>
              <input 
                type="text" 
                name="created_by" 
                className="form-control" 
                placeholder="Enter author name"
                required 
              />
            </Col>
          </Row>

          <Row>
          <Col md={4}>
            <div className="file_upload">
              <Form.Label>Image 1 (424 px X 550 px)</Form.Label>
              <Form.Control type="file" name="image1" />
            </div>
          </Col>

          <Col md={4}>
          <div className="file_upload">
            <Form.Label>Image 2 (394 px X 256 px)</Form.Label>
            <Form.Control type="file" name="image2" />
          </div>
          </Col>

          <Col md={4}>
          <div className="file_upload">
            <Form.Label>Image 3 (240 px X 220 px)</Form.Label>
            <Form.Control type="file" name="image3" />
          </div>
          </Col>

          </Row>


          {/* More form fields */}
          <Row className="mt-3">
            <Col md={6}>
              <label htmlFor="title">Title</label>
              <input type="text" name="title" className="form-control" required />
            </Col>
            <Col md={6}>
              <label htmlFor="slug">Slug</label>
              <input type="text" name="slug" className="form-control" required />
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <label htmlFor="tags">Tags</label>
              <Form.Select
                multiple
                value={selectedTags}
                onChange={(e) => setSelectedTags(Array.from(e.target.selectedOptions, option => option.value))}
                disabled={isLoading}
                required
              >
                {tags && tags.length > 0 ? (
                  tags.map((tag) => (
                    <option key={tag.name} value={tag.name}>{tag.name}</option>

                  ))
                ) : (
                  <option value="">No tags available</option>
                )}
              </Form.Select>
            </Col>

            <Col md={6}>
              <div className="file_upload">
                <Form.Label>Banner</Form.Label>
                <Form.Control type="file" name="banner" />
              </div>
            </Col>

          </Row>

          {/* Content */}
          <label htmlFor="content">Content</label>
          <ReactQuill value={value} onChange={setValue} required />

          <button type="submit" className="btn create_btn mt-4" disabled={isLoading}>
            {isLoading ? 'Submitting...' : isEditMode ? 'Update Blog' : 'Create Blog'}
          </button>
        </form>
        
        <style jsx>{`
          .pagination {
            margin-top: 20px;
            text-align: center;
          }
          .pagination button {
            margin: 0 5px;
            padding: 5px 10px;
            border: none;
            background-color: #eee;
            cursor: pointer;
          }
          .pagination button.active {
            background-color: #4caf50;
            color: white;
          }
        `}</style>


        <div className="content_wrapper blog_wrapper">
          <div className="table-responsive">
            {isLoading ? (
              <div>Loading...</div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Category</th>
                    <th>Date</th>
                    <th>Title</th>
                    <th>Author</th>
                    <th>Featured</th>
                    <th>Spotlight</th>
                    <th>Slider</th>
                    {role === 'Admin' && <th>Approve</th>}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {blogs && blogs.length > 0 ? (
                    blogs.map((blog, index) => (
                      <tr key={blog.id}>
                        <td>{(currentPage - 1) * blogsPerPage + index + 1}</td>

                        <td>{blog.category}</td>
                        <td>{dayjs(blog.created_at).format('DD/MM/YYYY')}</td>
                        <td>{blog.title}</td>
                        <td>{blog.created_by}</td>
                        <td>
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={blog.featured === 1}
                              onChange={() => handleToggle(blog.id, 'featured', blog.featured ? 0 : 1)}
                            />
                            <span className="slider"></span>
                          </label>
                        </td>

                        <td>
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={blog.spotlight === 1}
                              onChange={() => handleToggle(blog.id, 'spotlight', blog.spotlight ? 0 : 1)}
                            />
                            <span className="slider"></span>
                          </label>
                        </td>

                        <td>
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={blog.slider === 1}
                              onChange={() => handleToggle(blog.id, 'slider', blog.slider ? 0 : 1)}
                            />
                            <span className="slider"></span>
                          </label>
                        </td>
                       {role === 'Admin' && (
  <td>
    <label className="switch">
      <input
        type="checkbox"
        checked={blog.approved === 1}
        onChange={() => handleToggle(blog.id, 'approved', blog.approved ? 0 : 1)}
      />
      <span className="slider"></span>
    </label>
  </td>
)}

                        <td className='action_td'>
                          <button onClick={() => handleEdit(blog.id)}>Edit</button>
                          <button onClick={() => handleDelete(blog.id)} className='d-block py-2'>Delete</button>
                          <Link to={`/admin/blog-meta-tags/${blog.id}`} >Edit Meta Tag</Link><br></br>
                          <Link to={`/e-magazine/${blog.category}/${blog.slug}`} >Preview Blog</Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">No blogs available</td>
                    </tr>
                  )}
                </tbody>
                <style jsx>{`
                  .switch {
                    position: relative;
                    display: inline-block;
                    width: 40px;
                    height: 20px;
                  }

                  .switch input {
                    opacity: 0;
                    width: 0;
                    height: 0;
                  }

                  .slider {
                    position: absolute;
                    cursor: pointer;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: #ccc;
                    transition: 0.4s;
                    border-radius: 20px;
                  }

                  .slider:before {
                    position: absolute;
                    content: "";
                    height: 14px;
                    width: 14px;
                    left: 4px;
                    bottom: 3px;
                    background-color: white;
                    transition: 0.4s;
                    border-radius: 50%;
                  }

                  input:checked + .slider {
                    background-color: #4caf50;
                  }

                  input:checked + .slider:before {
                    transform: translateX(18px);
                  }
                `}</style>
              </table>
            )}


{totalPages > 1 && (
  <div className="pagination">
    {Array.from({ length: totalPages }, (_, index) => (
      <button
        key={index}
        onClick={() => fetchBlogs(index + 1)}
        className={currentPage === index + 1 ? 'active' : ''}
      >
        {index + 1}
      </button>
    ))}
  </div>
)}


          </div>
        </div>

      </div>
      <ToastContainer />
    </>
  );
}

export default Blog;
